export default __webpack_public_path__ + "media/metronic/_theme/media/logos/favicon-c619ce6559b7246689151a85989ac39a.ico";